import { ICenterType, IContactPosition } from "./index";

export interface IContactEntityType {
    //contactPositionId: number;
    entityTypeId: number,
    entityTypeDescription: string;
    centerTypes: ICenterType[],
    contactPositions: IContactPosition[]
}